import {
  LocalizeConfig,
  LocalizeDefaultConfig,
  LocalizeLanguages,
} from "smarthub-common";
import { IProps } from "./props";

const genericText = {
  en: {
    chatHeadTitle: "ICO's digital assistant",
    chatHeadTitleLabel: "ICO's digital assistant",
    chatHeadSubTitle: "I'm here to answer your questions.",
    chatHeadSubTitleLabel: "I'm here to answer your questions.",
  },
};

const textMapping = {
  generic: genericText,
};

export const localize = ({ id }: IProps): LocalizeConfig => {
  return {
    defaultLanguage: LocalizeLanguages.en,
    [LocalizeLanguages.en]: {
      ...LocalizeDefaultConfig.en,
      ...textMapping[id].en,
    },
  };
};
